import * as React from "react";
import { TableCell, TableRow } from "../widget";
import { WithStyles, withStyles, createStyles, Theme, StyleRulesCallback } from '../mui/styles';

export interface DataErrorProps {
    colSpan: number;
    message?: string;
}

class DataError extends React.PureComponent<DataErrorProps & WithStyles<typeof styles>>{

    render() {
        const { colSpan, message, classes } = this.props;

        return <TableRow>
            <TableCell className="text-center" colSpan={colSpan}><div className={classes.error}>{message}</div></TableCell>
        </TableRow>;
    }
}



const styles = ((theme: Theme) => createStyles({
    error: {
        color: theme.palette.error.main,
    },
})) as StyleRulesCallback;

export default withStyles(styles)(DataError);